import { useOrgan } from "../hooks/useOrgan";
import { Box, CircularProgress } from "@mui/material";
import "../assets/styles/custom-styles.css";
import PermanentSidebarMUI, {
  organizationPrimaryColors,
} from "./PermanentSidebarMUI";

const MainLayout = ({ children, loadingPage }) => {
  const { loading, selectedOrgan } = useOrgan();

  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM;

  return (
    <Box
      id="wrapper"
      className="flex"
      sx={{ backgroundColor: "rgb(246, 246, 246)" }}>
      {loading || loadingPage ? (
        <div
          className="d-flex justify-content-center align-items-center w-100"
          style={{ height: "100vh" }}>
          <CircularProgress
            sx={{
              color: primaryColor,
            }}
          />
        </div>
      ) : (
        <>
          <PermanentSidebarMUI children={children}></PermanentSidebarMUI>
        </>
      )}
    </Box>
  );
};

export default MainLayout;
